import React from "react";
import styles from "../style/announcement.module.css";

function getRightIcon() {
    return (
        <svg
            width="6"
            height="11"
            viewBox="0 0 6 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.announcement_right_icon}
        >
            <path
                d="M5.37318 4.82145C5.72711 5.20459 5.72711 5.79541 5.37318 6.17855L1.73455 10.1175C1.11698 10.786 -6.29574e-08 10.3491 -2.31744e-08 9.43893L3.21178e-07 1.56107C3.60961e-07 0.650938 1.11698 0.213979 1.73455 0.882518L5.37318 4.82145Z"
                fill="white"
            />
        </svg>
    );
}

type AnnouncementProps = {
    heading: string;
    text: string;
    link: string;
};
export default function Announcement({ heading, text, link }: AnnouncementProps) {
    return (
        <div className="announcement_wrapper">
            <div className="announcement_offset"></div>
            <div className="announcement_container">
                <div className="announcement_topic_container">
                    {/* {getStarIcon()} */}
                    <span className="announcement_topic">{heading}</span>
                </div>

                <a href={link} className="announcement_link">
                    <span className="announcement_text">{text}</span>
                    {getRightIcon()}
                </a>
            </div>
        </div>
    );
}
